import { Box, Button, ButtonBaseProps, Menu, MenuItem } from '@mui/material'
import { tannBlue } from '../../utils/theme/colors'
import React from 'react'
import { useAppHeaderMenuItems } from './useAppHeaderMenuItems'
import { NavLink } from 'react-router-dom'
import { styled } from '../../core'
import { useSelector } from 'react-redux'
import { canViewRoleMatrix, canViewTaxonomy } from 'store/selectors/role-selectors'
import { navigate } from 'app/store'
import { authInfo } from 'store/selectors/auth-selectors'

const SMenuItem = styled(Button)<ButtonBaseProps>`
    height: 56px;
    font-size: 14px;
    padding: 8px;
    text-transform: uppercase;
    border-radius: 0;

    &.active {
        color: ${tannBlue};
    }

    &:hover {
        opacity: 0.75;
    }
`

export const AppHeaderMenu: React.FC = () => {
    const { menuItems } = useAppHeaderMenuItems()
    let hasRolesMenuItem = !!useSelector(canViewRoleMatrix)
    let hasTaxonomyMenuItem = !!useSelector(canViewTaxonomy)

    const auth = useSelector(authInfo)
    const isAdmin = auth.user?.role === 'adm'

    const adminItems = [
        {
            id: 'Taxonomy',
            label: 'Taxonomy',
            url: '/taxonomy',
            condition: () => hasTaxonomyMenuItem,
        },
        {
            id: 'Roles',
            label: 'Roles',
            url: '/roles',
            condition: () => hasRolesMenuItem,
        },
        {
            id: 'ChangeRequests',
            label: 'Change Requests',
            url: '/change-requests',
            condition: () => hasTaxonomyMenuItem,
        },
    ]

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    return (
        <Box component="div" sx={{ flexGrow: 1, display: 'flex', marginLeft: '20px', gap: '4px' }}>
            {menuItems.map((menuItem) => (
                <SMenuItem
                    {...{
                        key: menuItem.id,
                        color: 'inherit',
                        variant: 'text',
                        to: menuItem.url,
                        component: NavLink,
                    }}
                >
                    {menuItem.label}
                </SMenuItem>
            ))}

            {(hasTaxonomyMenuItem || hasRolesMenuItem || isAdmin) && (
                <>
                    <SMenuItem
                        id="basic-button"
                        aria-controls={open ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClick}
                    >
                        Admin
                    </SMenuItem>

                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                    >
                        {adminItems.map((item) => (
                            <MenuItem
                              key={item.id}
                                onClick={() => {
                                    handleClose()
                                    navigate(item.url)
                                }}
                            >
                                {item.label}
                            </MenuItem>
                        ))}
                    </Menu>
                </>
            )}
        </Box>
    )
}
